<template>
    <v-layout justify-center>
        <v-responsive width="100%" max-width="1080" height="100%" class="mx-n3 px-3">
            <list-heading v-bind="{ title }" />

            <report-view-head v-bind="{ process, planDate }" class="mb-4" />
            <report-view-body v-bind="{ process, planDate }" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ReportViewHead from "@/components/console/mes/reports/report-view-head.vue";
import ReportViewBody from "@/components/console/mes/reports/report-view-body.vue";

export default {
    components: {
        ListHeading,
        ReportViewHead,
        ReportViewBody,
    },
    props: {
        process: { type: String },
        planDate: { type: String },
    },
    data: () => ({
        report: undefined,
        loading: false,
    }),
    computed: {
        title() {
            return `${this.report?.PLAN_DATE || this.planDate} ${this.report?.PROCESS || this.process} 생산보고서`;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        process() {
            this.init();
        },
        planDate() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { process, planDate } = this;
                let { report } = await api.console.mes.reports.get({ process, planDate });
                this.report = report;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
